(function (Drupal, drupalSettings) {
  Drupal.behaviors.externeSwiper = {
    attach: function (context, settings) {
      const externeElements = context.querySelectorAll(".swiper-externe");
      externeElements.forEach((externe) => {
        if (!externe.dataset.externeSwiperProcessed) {
          externe.dataset.externeSwiperProcessed = "true";

          const slides = externe.querySelectorAll(".swiper-slide");
          const swiperConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
          };

          if (slides.length > 1) {
            swiperConfig.loop = true;
            swiperConfig.autoplay = {
              delay: 2500,
              disableOnInteraction: false,
            };
          }

          new Swiper(externe, swiperConfig);
        }
      });
    },
  };
})(Drupal, drupalSettings);
